import React from 'react';
import CrudEntryWrapper from 'components/CrudHOC';
import FormWrapper from 'components/FormWrapper';
import ContentWrapper from 'components/ContentWrapper';
import { resetForm } from './redux';
import Form from './Form';
import { setup } from './setup';

const EntryWrapper = (props) => {
  const { saveEntry, data } = props;

  const displayTitle = `${data.name}`;

  // const permissions = useSelector(state => state.users.entry.permissions);
  const tabs = [
    {
      label: 'Details',
      component: <Form />,
    },
  ];

  // const permissions = useSelector(state => state.users.entry.permissions);

  return (
    <ContentWrapper fullWidth={false}>
      <FormWrapper
        setup={setup}
        reset={resetForm}
        displayTitle={displayTitle}
        tabs={tabs}
        initialValues={data}
        onSubmit={saveEntry}
        seo={false}
      />
    </ContentWrapper>
  );
};

const EntryWrapperWithCrud = CrudEntryWrapper(EntryWrapper, setup);

export default EntryWrapperWithCrud;
